import { BeckyModel } from '../types/becky'

export function deStringifyExperiments(beckyExperiments: string | undefined): BeckyModel['experiments'] {
	if (!beckyExperiments) {
		return {}
	}

	const experiments = beckyExperiments.split(',').reduce((acc, exp) => {
		const expKeyAndValue = exp.split(':')
		return {
			...acc,
			[expKeyAndValue[0]]: expKeyAndValue[1],
		}
	}, {})

	return fixExperimentsValues(experiments)
}

export const fixExperimentsValues = (experiments: BeckyModel['experiments']) => {
	if (!experiments) {
		return {}
	}

	return Object.entries(experiments).reduce<Record<string, boolean | string>>((acc, [key, value]) => {
		if (value === 'new' || value === 'true') {
			acc[key] = true
		} else if (value === 'old' || value === 'false') {
			acc[key] = false
		} else {
			acc[key] = value
		}
		return acc
	}, {})
}
